export default {
	loading          : false,
	loginToken       : null,
	passwordToken    : null,
	signupToken      : null,
	accessToken      : null,
	tokenType        : null,
	companyCode      : null,
	signupEmail      : '',
	confirmCode      : '',
	confirmCodeLength: 6
}
